import { Grid } from "@mui/material";
import ContentSection from "../../ContentSection";
import MxFormL3TextDateField from "@rf-l3/form/MxFormL3DatePickerField";
import MxFormL4DocumentFileProperty from "@/src-refactor/modules/shared/components/refactor/components/l4/form/MxFormL4DocumentFileProperty";
import MxTypography from "@rf-l1/MxTypography";
import useValidateExplicitField from "../../hooks/useValidateExplicitField";
import { useFormValidationsDocumentsMsgSlice } from "@rf/property/module/components/property-form/store/slices/form-validations-documents-msg/FormValidationsDocumentsMsgSlice";
import { CPropertyValidationDocumentKeys } from "@rf/property/module/components/property-form/util/schemas/validation-documents/validation-document.schema";
import useShowValidationInfo from "@rf/property/module/components/modal/useShowValidationInfo";
import { IFileData } from "@rf-l1/file/helpers/create-file-data";
import { CValidationDocumentKeys } from "../../../../../../../util/model/documents-types";

const CityHall = () => {
  const {
    validationDocuments: { no_objection, deposit_at_town_hall }
  } = useFormValidationsDocumentsMsgSlice();

  return (
    <ContentSection
      title="No objeción ayuntamiento"
      tooltip="No objeción ayuntamiento"
      color="blue"
      alert={no_objection?.alert || deposit_at_town_hall?.alert}
    >
      <Grid container item xs={12} spacing={2}>
        <Deposito />
        <NoObjection />
      </Grid>
    </ContentSection>
  );
};

export default CityHall;

const NoObjection = () => {
  const {
    validationDocuments: { no_objection }
  } = useFormValidationsDocumentsMsgSlice();
  const { validateField } = useValidateExplicitField();
  const { showNotification } = useShowValidationInfo();

  const handleOnClickOnExternalIndicators = (
    file: IFileData | null,
    ctx: any,
    itemCtx: any
  ) => {
    showNotification(itemCtx.msg, itemCtx.status);
  };

  return (
    <Grid container item xs={3}>
      <Grid container item xs={12}>
        <Grid item xs={12}>
          <MxFormL4DocumentFileProperty
            withreacthookform={1}
            name={CPropertyValidationDocumentKeys.file_no_objection_from_town_hall}
            label="No objeción del ayuntamiento"
            maxSize={3}
            minSize={0}
            disabled={no_objection?.disabled}
            typeKey={CValidationDocumentKeys.NoObjection}
          />
        </Grid>
        <Grid item xs="auto" alignItems="center"></Grid>
        <Grid item xs={12} mt={2.5}>
          <MxFormL3TextDateField
            withreacthookform={1}
            name={CPropertyValidationDocumentKeys.date_no_objection_issuance}
            label="Fecha de emisión"
            disabled={no_objection?.disabled}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

const Deposito = () => {
  const {
    validationDocuments: { deposit_at_town_hall }
  } = useFormValidationsDocumentsMsgSlice();
  const { validateField } = useValidateExplicitField();

  const { showNotification } = useShowValidationInfo();

  const handleOnClickOnExternalIndicators = (
    file: IFileData | null,
    ctx: any,
    itemCtx: any
  ) => {
    showNotification(itemCtx.msg, itemCtx.status);
  };

  return (
    <Grid container item xs={3}>
      <Grid container item xs={12}>
        <Grid item xs={12}>
          <MxFormL4DocumentFileProperty
            withreacthookform={1}
            maxSize={3}
            minSize={0}
            name={CPropertyValidationDocumentKeys.file_deposit_in_town_hall}
            label="Depósito en ayuntamiento"
            disabled={deposit_at_town_hall?.disabled}
            typeKey={CValidationDocumentKeys.DepositAtTownHall}
          />
        </Grid>
        <Grid item xs="auto" alignItems="center" my={1}>
          <MxTypography align="center" color="grey.500" variant="overline">
            Este documento debe subirse un mes después de la no objeción
          </MxTypography>
        </Grid>

        <Grid item xs={12}>
          <MxFormL3TextDateField
            withreacthookform={1}
            name={CPropertyValidationDocumentKeys.date_deposit_town_hall}
            label="Fecha de depósito"
            disabled={deposit_at_town_hall?.disabled}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
